import Vue         from 'vue'
import App         from './components/App.vue'
import Vuetify     from 'vuetify'
import router      from './router';
import axios       from 'axios'
import store       from './store';
import VueForceNextTick from 'vue-force-next-tick' //added 2024-07-11 jazz
import hanzenkaku from 'hanzenkaku';
// import VueTheMask  from 'vue-the-mask';
import VueSweetAlert2  from 'vue-sweetalert2';

// import 'sweetalert2/dist/sweetalert2.min.css'; //2025-08-22 jazz

// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import '@mdi/font/css/materialdesignicons.css'
 
// import 'vuetify/dist/vuetify.css'
// import '../css/CustomCSS.css' 

import * as Account from '././class/SRSParts/Account'
import * as GaibuList from '././class/SRSParts/GaibuList'
import * as SetsubiSheet from '././class/SRSParts/SetsubiSheet'
import * as BasicSpecs from '././class/SRSParts/BasicSpecs'
// import * as PlanData from '././class/SRSParts/PlanData'
import * as SRSFunc from '././class/SRSParts/SRSFunctions';
import * as Const from '././class/SRSParts/Constants';
import * as Progress from '././class/SRSParts/Progress';
import * as WebsocketService from '././class/SRSParts/WebsocketService';

//2025-04-07 jazz
import { globalMixin } from './globalMixin';

// axios.defaults.timeout = 60000; //set default timeout for axios in milliseconds

require('./bootstrap');

Vue.config.productionTip = false;
Vue.use(Vuetify);
// Vue.use(VueTheMask);
Vue.use(VueSweetAlert2);
Vue.use(hanzenkaku);
Vue.use(VueForceNextTick); //added 2024-07-11 jazz

Vue.config.devtools = process.env.MIX_DEBUG //2025-05-08, use vue-dev tools in chrome when debug mode

Vue.mixin(globalMixin); //global mixin 2025-04-07 jazz
 

if(!navigator.userAgent.includes("Chrome")){
    alert('Please use google chrome browser or Microsoft Edge')

    do {
        alert('Please use google chrome browser or Microsoft Edge')
    }
    while (!navigator.userAgent.includes("Chrome"));
}

//2025-09-29
Vue.prototype.$Axios = axios.create({
    timeout: 60000,
    headers: {
        'SRS-Key': process.env.MIX_API_KEY,
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
    },
})

if ( process.env.MIX_DEPLOYMENT === 'ichijo' ) {
    //socket URL
    const socketURIArr = [
        process.env.MIX_WEBSOCKET_SERVER,
        process.env.MIX_WEBSOCKET_SERVER2
    ];

    //2025-09-02 jazz
    let socketUri = socketURIArr.filter(item => item.split('//')[1].slice(0, 6) !== store.state.UserInterface.SocketURI )[0]

    if(!socketUri){
        socketUri = socketURIArr[0];
    }

    const switchSocket = socketUri.split('//')[1].slice(0, 6)

    store.dispatch('SaveSocketURI', switchSocket)
 
    // const randomIndex = Math.floor(Math.random() * socketURIArr.length);
    // Vue.prototype.$WebsocketService = new WebsocketService.Socket( socketURIArr[randomIndex], axios )

    //2025-09-02 jazz
    Vue.prototype.$WebsocketService = new WebsocketService.Socket( socketUri, Vue.prototype.$Axios ) //2025-09-29 jazz
}

 
Vue.prototype.$CRSOpenOnly   = process.env.MIX_ALLOW_ONLY_CRS_OPEN == 1 ? true: false; //2025-09-16 jazz
Vue.prototype.$PlanData      = null;
Vue.prototype.$convert       = hanzenkaku;
Vue.prototype.$UserInfo      = new Account.UserInfo(Vue.prototype.$Axios); //2025-09-29
Vue.prototype.$GaibuList     = new GaibuList.Gaibu(`${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/###/1`, Vue.prototype.$Axios);
Vue.prototype.$SetsubiSheet  = new SetsubiSheet.Setsubi(`${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/###/2`, Vue.prototype.$Axios);
Vue.prototype.$BasicSpecs    = new BasicSpecs.BasicSpecs(`${process.env.MIX_API_BASEURL}/api/shiyo-common/type-betsu/get-srs-applicable-items/###/3`, Vue.prototype.$Axios);
Vue.prototype.$SRSFunc       = SRSFunc;


Vue.prototype.$SRSFunc.SRSDefaults.axiosObj = Vue.prototype.$Axios; //2025-09-29 jazz 


Vue.prototype.$Const         = Const;
Vue.prototype.$ProgressBar   = new Progress.Progress();
// Vue.prototype.$SRSFunc.SRSDefaults.ImportFontAPIWorker(); //import Font using webworker

export const bus = new Vue(); //event bus

//2026-10-29 jazz, UC-017 CRS-SRS token handoff (URL-1) - launched via
//{SRS_WEB_BASE}/?customer_code=...&plan_number=...&token=...&srs_id=...
//Validated here, before the app ever mounts, so every other URL shape (i.e. every
//existing flow) reaches the unchanged mountApp() call below exactly as before.
//
//On success this bridges into the EXISTING, unmodified /acceptredirect route - that
//route's auto-login (router/index.js's beforeEach guard) only fires when it's the
//very first navigation on this router instance (from.name === null), matching how
//CRS already opens it today as a fresh popup. So this must be the first and only
//router call made here - no intermediate route - otherwise the guard treats it as an
//already-logged-in-or-not case instead and bounces to /login.
function mountApp() {
    new Vue({
        el: '#app',
        vuetify: new Vuetify(),
        router,
        store,
        //axios,
        components: { App },
        template: '<App/>'
    });
}

function showHandoffFailure() {
    document.getElementById('app').innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;">
            <div style="text-align:center;">
                <p>This link has expired or is invalid.<br>Please open it again from CRS.</p>
                <button onclick="window.close()">OK</button>
            </div>
        </div>`;
}

async function bootstrap() {
    const handoffParams = new URLSearchParams(window.location.search);
    const token = handoffParams.get('token');
    const srsId = handoffParams.get('srs_id');
    const customerCode = handoffParams.get('customer_code');
    const planNumber = handoffParams.get('plan_number');

    if (!(token && srsId && customerCode && planNumber)) {
        mountApp();
        return;
    }

    document.getElementById('app').innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;">
            <p>Opening SRS&hellip;</p>
        </div>`;

    try {
        const validateRes = await axios.post(`${process.env.MIX_API_BASEURL}/api/handoff/validate`, {
            token: token,
            srs_id: srsId,
            customer_code: customerCode,
            plan_number: planNumber,
        });

        if (!validateRes.data || !validateRes.data.valid) {
            showHandoffFailure();
            return;
        }

        //'user' is an optional, non-validated UC-017 query param (not part of the backend
        //contract) - passed through as the :username segment so it shows up via the existing
        //"Welcome {username}!" app-bar display (App.vue's UserName, set by router/index.js's
        //guard from this same param on the existing AcceptRedirect route).
        const username = handoffParams.get('user') || 'CRS Linkage'
        const email = handoffParams.get('user') || 'crs-linkage@hrd-s.com'
        const houseType = handoffParams.get('house_type') || ''
        const uniqueId = Math.floor(Math.random() * 9000)

        await router.replace(
            `/acceptredirect/${encodeURIComponent(email)}/${encodeURIComponent(username)}`
            + `/${encodeURIComponent(customerCode)}/${encodeURIComponent(planNumber)}`
            + `/${encodeURIComponent(houseType)}/${process.env.MIX_API_KEY}/${uniqueId}`
        );

        mountApp();
    } catch (error) {
        console.log(error);
        showHandoffFailure();
    }
}

bootstrap();
